module.exports = __webpack_public_path__ + "media/images/dividend/ill-beach-47158355ade4e25c804321c7121c3999.svg";